'use client';

var translations = {
    "What's new": 'Tính năng mới',
    'View Win Rate Details': 'Xem Chi Tiết Tỷ Lệ Thắng',
    'Got It': 'Đã Hiểu',
    'View stats': 'Xem thống kê',
    'Track My Competitive Rate': 'Theo Dõi Tỷ Lệ Cạnh Tranh Của Tôi',
    'Track my competitive rate': 'Theo dõi tỷ lệ cạnh tranh của tôi',
    'VietnamWorks calculates your competitive rate based on your application information and compares it with other candidates for this job after you apply.': 'VietnamWorks tính toán tỷ lệ cạnh tranh của bạn dựa trên thông tin ứng tuyển của bạn và so sánh nó với các ứng viên khác cho công việc này sau khi bạn ứng tuyển.',
    '/track-my-competitive-rate/': '/theo-doi-ty-le-canh-tranh-cua-toi/',
    'Create CV to apply': 'Tạo CV để ứng tuyển',
    'Apply Now': 'Nộp Đơn'
};

export { translations as default };
//# sourceMappingURL=translations.js.map
